// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"f7e23086","655":"a58527b7","727":"0a23e27f","853":"c235f5ac"}[chunkId] + ".chunk.css";
};